import {
  DrillAnalyticsScreen,
  DrillCompetencyScreen,
  DrillDashboardScreen,
  DrillLibraryScreen,
  DrillPlannerScreen,
  DrillRecordsScreen,
  TrainingNeedsScreen,
} from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import {
  officeDrillAnalyticsSource,
  officeDrillCompetencySource,
  officeDrillLibrarySource,
  officeDrillPlanSource,
  officeDrillRecordSource,
  officeTrainingNeedSource,
} from '../drills-source.js';

/**
 * Operations ▸ Drills ▸ Library (ADR 0128 Faz 1): şirketin tatbikat Master Library'si; şablon ve
 * kategori yazma, Excel içe/dışa aktarma, varsayılan kütüphane.
 */
export function DrillLibraryPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDrillsLibrary')}>
      <DrillLibraryScreen source={officeDrillLibrarySource} />
    </Shell>
  );
}

/** Operations ▸ Drills ▸ Dashboard (ADR 0128 Faz 2 Ek): filonun dönem KPI'ları ve karşılaştırması. */
export function DrillDashboardPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDrillsDashboard')}>
      <DrillDashboardScreen source={officeDrillPlanSource} />
    </Shell>
  );
}

/** Operations ▸ Drills ▸ Planner (ADR 0128 Faz 2 Ek): filo planı, gemi senaryosu kararı, kural seti. */
export function DrillPlannerPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDrillsPlanner')}>
      <DrillPlannerScreen source={officeDrillPlanSource} />
    </Shell>
  );
}

/** Operations ▸ Drills ▸ Records (ADR 0128 Faz 3 Ek): filonun tatbikat icra kayıtları, salt okunur. */
export function DrillRecordsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDrillsRecords')}>
      <DrillRecordsScreen source={officeDrillRecordSource} />
    </Shell>
  );
}

/** Operations ▸ Drills ▸ Crew Competency (ADR 0128 Faz 4 Ek): kişi × tatbikat matrisi. */
export function DrillCompetencyPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDrillsCompetency')}>
      <DrillCompetencyScreen source={officeDrillCompetencySource} />
    </Shell>
  );
}

/** Crew ▸ Training & Courses (ADR 0128 Faz 4 Ek): gemilerin eğitim ihtiyaçları, salt okunur. */
export function TrainingNeedsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.crewTraining')}>
      <TrainingNeedsScreen source={officeTrainingNeedSource} />
    </Shell>
  );
}

/**
 * Operations ▸ Drills ▸ Analytics (ADR 0128 Faz 5 Ek): filo karşılaştırması, eğilim ve tür
 * dağılımı; Excel dışa aktarım. Yalnız ofiste.
 */
export function DrillAnalyticsPage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('menu.operationsDrillsAnalytics')}>
      <DrillAnalyticsScreen source={officeDrillAnalyticsSource} />
    </Shell>
  );
}
